export default __webpack_public_path__ + "static/media/logo-mark.31f4d585.svg";